import { useState } from "react";
import Input from "../../../design/Input";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";


export default function FrequentFlyer ({data, setData}) {
    const dataDict = {compny: '', code: '', number: '', remark: '', num: 0};
    const head = ["מס'", "חברה", "קוד", "מספר", "הערות", "", ""];
    const [dataContact, setDataContact] = useState(dataDict);

    const myInsertff = () => {
        if (regx('compny', dataContact.compny) && regx('code', dataContact.code) && regx('passpord', dataContact.number, false) && regx('strEnHe', dataContact.remark)) {
            let num;
            if (dataContact.num === 0) {
                let keys = Object.keys(data.ff);
                num = (keys.length ? Math.max(...keys) : 0) + 1
            } else {
                num = dataContact.num;
            }
            let ff = {...data.ff, [num]: dataContact};
            setData({...data, ff: ff});
            setDataContact(dataDict);
        }
    }


    return (
        <div>
            <div className="divOfFF">
                <p>חברה</p>
                <Input 
                textView="חברה" 
                myStyle='input2' 
                value={dataContact.compny} 
                onChange={(e) => setDataContact({...dataContact, compny: e})} 
                pattern={'compny'} 
                />
                <p> קוד </p>
                <Input 
                textView="קוד" 
                myStyle='input2' 
                value={dataContact.code} 
                onChange={(e) => setDataContact({...dataContact, code: e})} 
                pattern={'code'} 
                />
                <p>מספר </p>
                <Input 
                textView="מספר" 
                myStyle='input2' 
                value={dataContact.number} 
                onChange={(e) => setDataContact({...dataContact, number: e})} 
                pattern={'passpord'} 
                />
                <p> הערות </p>
                <Input 
                textView="הערות" 
                myStyle='input2' 
                value={dataContact.remark} 
                onChange={(e) => setDataContact({...dataContact, remark: e}) } 
                pattern={'strEnHe'} 
                />
            </div>

            <p className="addPasspord" onClick={myInsertff} > הוסף \ עדכן</p>

            <TableDatalis 
            head={head}
            data={data.ff}
            name={'ff'} 
            edit={(value) => setDataContact({...data.ff[value], num: value})}
            myDelete={(value) => {
                let ff = data.ff;
                delete ff[value];
                setData({...data, ff: {...ff}});
            }}
            />
        </div>
    )
}